var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Blade1'),_c('Blade1a'),_c('Blade2'),_c('Blade3'),_c('Factoid'),_c('Blade4'),_c('Blade5'),_c('Blade6')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }